import { console } from 'react-redux-app/lib/modules/core/utils';
import { handleOnEnterException } from 'react-redux-app/lib/modules/routing/utils';

import { INTERNAL_ERROR_URI } from 'react-redux-app/lib/modules/routing/constants';
import { maybeHandleCriticalError } from 'react-redux-app/lib/modules/api/utils';

import { actionLoadWebmasterProfileRequest } from '../../../webmaster/actions/profile';
import {
  getLoadBalanceError,
  getWebmasterBalanceInCredits,
  getLoadWebmasterProfileError,
  getWebmasterProfile,
} from '../../../webmaster/selectors';

import { actionLoadBalanceRequest } from '../../../webmaster/actions/balance';


export default ({ getState, dispatch }) => (
  function getWebmasterInfoHandler(nextState, successCallback, errorCallback) {
    Promise.all([
      dispatch(actionLoadBalanceRequest()),
      dispatch(actionLoadWebmasterProfileRequest()),
    ]).then(
      () => {
        if (handleOnEnterException(getState(), errorCallback, INTERNAL_ERROR_URI)) {
          return;
        }

        const getBalanceError = getLoadBalanceError(getState());
        if (
          getBalanceError
          && maybeHandleCriticalError(
            nextState.location, getBalanceError.globalErrors, errorCallback
          )
        ) {
          return;
        }

        const getWebmasterProfileError = getLoadWebmasterProfileError(getState());
        if (
          getWebmasterProfileError
          && maybeHandleCriticalError(
            nextState.location, getWebmasterProfileError.globalErrors, errorCallback
          )
        ) {
          return;
        }

        if (getWebmasterBalanceInCredits(getState()) && getWebmasterProfile(getState())) {
          successCallback();
          return;
        }

        console.consoleError(
          `getWebmasterInfoHandler. Unable to get info about webmaster. Make redirect to ${INTERNAL_ERROR_URI}`
        );
        errorCallback(INTERNAL_ERROR_URI);
      }
    ).catch(error => {
      console.consoleError('getWebmasterInfoHandler failed', error);
      errorCallback(INTERNAL_ERROR_URI);
    });
  }
);
